export default "__VITE_ASSET__liWnIcMC__"